import script from "./adjustItem.vue?vue&type=script&setup=true&lang=js"
export * from "./adjustItem.vue?vue&type=script&setup=true&lang=js"

import "./adjustItem.vue?vue&type=style&index=0&id=12e844e2&lang=scss"

const __exports__ = script;

export default __exports__